import {
  FilterSortPopup,
  IStyles,
  IconWrapper,
  StudentScoreCard,
  deserify,
  firstLetterImage,
  getMediaBasePath,
  pxToRem,
  pxTovW,
} from '@geneo2-web/shared-ui';
import { Box, Button, Typography } from '@mui/material';
import {
  ModeOfConductionEnum,
  SubmissionType,
} from '@protos/learning_management/lms.db_pb';
import { SetStateAction, Dispatch, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../reduxStore/reduxHooks';
import { interactionEvent } from '../../../Auth/auth.events';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';
import { ISubmissionProps } from '../../../../components/StudentPerformanceGrid';
import { IStatusObj } from '../../../Assessment/ClickerAssessment/reducer/clickerAssessment.slice';
import {
  StudentOmrPerformanceInfo,
  StudentPerformanceInfo,
} from '@protos/learning_management/lms.assessment.teacher.apis_pb';
import TimeMismatchButton from '../../CompletedHomework/components/TimeMismatchButton';
import { DownloadStudentResponseStatusButton } from '../../components/DownloadStudentResponseStatus';

const styles: IStyles = {
  root: {
    width: { xs: '100%', md: '100%' },
    // display: 'flex',
    // flexDirection: 'column',
    paddingLeft: { xs: pxToRem(0), md: pxTovW(40) },
    paddingTop: { xs: pxToRem(20), md: pxTovW(0) },
    // paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    boxSizing: 'border-box',
    // overflowX: 'hidden',
  },
  header: {
    width: { xs: '94%', md: '100%', lg: '100%' },
    display: 'flex',
    marginLeft: { xs: '3%', md: 'auto' },
    // flexDirection: 'column',
    // paddingLeft: { xs: pxToRem(40), md: pxTovW(40) },
    // paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    gap: { xs: pxToRem(10), md: pxTovW(22) },
    justifyContent: 'space-between',
    alignItems: 'center',
    //
    // alignItems: 'center',
  },
};
type StudentInfo = StudentPerformanceInfo | StudentOmrPerformanceInfo;

interface IProps {
  Class: string;
  studentPerformanceInfoList?:
    | StudentPerformanceInfo[]
    | StudentOmrPerformanceInfo[];
  cardMaxMarks?: number;
  cardSubmissionType?: SubmissionType;
  cardOnClickHandler?: (studentId: string) => void;
  checkBoxClickHandler?: (props: ISubmissionProps) => Promise<void>;
  saveStudentInfo?: (props: StudentPerformanceInfo) => void;
  statusInfo?: IStatusObj;
  textClickHandler?: (studentInfo: StudentPerformanceInfo) => void;
  modeOfConduction?: ModeOfConductionEnum;
  assessmentName?: string;
  reportSubject?: string;
  reportClassName?: string;
  reportSection?: string;
  setOpenOmrUploadPopup?: Dispatch<SetStateAction<boolean>>;
  onMarkAttendanceClick?: () => void;
}
export const StudentSection = (props: IProps) => {
  const {
    Class,
    studentPerformanceInfoList,
    cardSubmissionType,
    cardMaxMarks,
    cardOnClickHandler,
    checkBoxClickHandler,
    // saveStudentInfo,
    statusInfo,
    textClickHandler,
    modeOfConduction,
    setOpenOmrUploadPopup,
    onMarkAttendanceClick,
  } = props;
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();

  const [studentList, setStudentList] = useState<StudentInfo[] | undefined>();
  const navigate = useNavigate();
  const { assessment_list_data, current_assessmemt_classStats } = deserify(
    useAppSelector((state) => state.manageHomework)
  );

  function splitName(fullName: string) {
    const nameParts = fullName.split(' ');
    const firstname = nameParts[0];
    const lastname = nameParts.slice(1).join(' '); // In case there are middle names or multiple last names

    return {
      firstname: firstname,
      lastname: lastname,
    };
  }
  useEffect(
    () => setStudentList(studentPerformanceInfoList as StudentInfo[]),
    [studentPerformanceInfoList]
  );

  const SortFunction = async (value: string) => {
    const temp = (studentPerformanceInfoList as StudentInfo[])?.slice();
    switch (value) {
      case 'Score: High to Low':
        temp?.sort((a, b) => b.scorePercent - a.scorePercent);
        setStudentList(temp);
        // console.log(temp);
        // console.log(studentList);
        await interactionEvent({
          context: 'sort_by',
          name: 'SCORE_HIGH_TO_LOW',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
        break;
      case 'Score: Low to High':
        temp?.sort((a, b) => a.scorePercent - b.scorePercent);
        setStudentList(temp);
        // console.log(temp);
        // console.log(studentList);
        await interactionEvent({
          context: 'sort_by',
          name: 'SCORE_LOW_TO_HIGH',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
        break;
      case 'First Name':
        temp?.sort((a, b) => {
          const FirstNameA = splitName(a.name).firstname;
          const FirstNameB = splitName(b.name).firstname;
          const nameA = FirstNameA.toLowerCase();
          const nameB = FirstNameB.toLowerCase();

          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          } else {
            return 0;
          }
        });
        setStudentList(temp);
        await interactionEvent({
          context: 'sort_by',
          name: 'FIRST_NAME',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
        break;
      case 'Last Name':
        temp?.sort((a, b) => {
          const LastNameA = splitName(a.name).lastname;
          const LastNameB = splitName(b.name).lastname;
          const nameA = LastNameA.toLowerCase();
          const nameB = LastNameB.toLowerCase();

          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          } else {
            return 0;
          }
        });
        setStudentList(temp);
        await interactionEvent({
          context: 'sort_by',
          name: 'LAST_NAME',
          pathSegments: pathSegments,
          isOffline: isOffline,
        });
        break;

      default:
        break;
    }
  };

  const FilterFunction = (value: string) => {
    const temp = studentPerformanceInfoList as StudentInfo[] | undefined;
    switch (value) {
      case 'High Score':
        setStudentList(temp?.filter((elem) => elem.scorePercent > 80));
        // console.log(temp?.filter((elem) => elem.scorePercent > 80));
        break;
      case 'Low Score':
        setStudentList(temp?.filter((elem) => elem.scorePercent < 30));
        break;
      case 'Medium Score':
        setStudentList(
          temp?.filter(
            (elem) => elem.scorePercent > 30 && elem.scorePercent < 80
          )
        );
        break;

      default:
        break;
    }
  };
  return (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h2" fontWeight="medium">
            Students
          </Typography>
          <Typography
            variant="cardText"
            fontWeight="bold"
            sx={{ color: '#007CDC' }}
          >
            Class {Class}
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: pxToRem(5), md: pxTovW(7) },
          }}
        >
          {modeOfConduction ===
            ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR && (
            <Button
              startIcon={
                <IconWrapper
                  name="scan-white"
                  type="png"
                  parentFolder="icons"
                  size="md"
                />
              }
              onClick={() =>
                setOpenOmrUploadPopup && setOpenOmrUploadPopup(true)
              }
              sx={{
                backgroundColor: '#0AA34F',
                padding: { xs: pxToRem(10), md: pxTovW(10) },
                '&:hover': {
                  backgroundColor: 'success.main',
                },
              }}
            >
              <Typography variant="h4" color="white">
                Scan Student Answer Sheet
              </Typography>
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              gap: { xs: pxToRem(10), md: pxTovW(22) },
              alignItems: 'center',
              flexDirection: {
                xs: 'column',
                md: 'row',
              },
            }}
          >
            {onMarkAttendanceClick && (
              <Button
                sx={{
                  cursor: 'pointer',
                  border: '1px solid #158D29',
                  borderRadius: pxToRem(10),
                  background: '#0AA34F',
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  gap: pxToRem(10),
                  '&:hover': {
                    background: '#0AA34F',
                  },
                }}
                onClick={onMarkAttendanceClick}
              >
                Mark Attendance
              </Button>
            )}

            <TimeMismatchButton
              studentPerformanceInfoList={studentPerformanceInfoList}
            />
          </Box>

          <FilterSortPopup
            iconName="Sort"
            title="Sort By"
            options={[
              'First Name',
              'Last Name',
              'Score: Low to High',
              'Score: High to Low',
            ]}
            sortFunction={SortFunction}
          />
          {/* <FilterSortPopup
            iconName="Filter"
            title="Filter"
            options={['High Score', 'Low Score', 'Medium Score']}
            filterFunction={FilterFunction}
          /> */}
        </Box>
      </Box>
      <Box
        sx={{
          // lg was a fixed pxTovW(754) — didn't reliably match the right
          // column's own actual width (OverviewBox and the header row above
          // both just use 100%), so this card's right edge could sit short
          // of theirs at desktop widths. boxSizing:border-box keeps the
          // padding below from pushing it back out past 100%. xs/md left
          // as-is (100vw/pxTovW(1100)) — not the reported mismatch.
          width: {
            xs: '100vw',
            md: pxTovW(1100),
            lg: '100%',
          },
          boxSizing: 'border-box',
          marginLeft: 'auto',
          paddingLeft: { xs: pxToRem(20), md: pxTovW(19) },
          paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
          paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
          paddingRight: { xs: pxToRem(0), md: pxTovW(19) },
          boxShadow: `0px 0px ${pxToRem(13)} #E0DFDE`,
          backgroundColor: '#FFFFFF',
          borderRadius: '5px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          rowGap: { xs: pxToRem(20), md: pxTovW(30) },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: { xs: '90vw', md: '100%' },
          }}
        >
          <DownloadStudentResponseStatusButton
            students={studentPerformanceInfoList}
            maxMarks={cardMaxMarks}
            assessmentName={props.assessmentName}
            subject={props.reportSubject}
            grade={props.reportClassName}
            section={props.reportSection}
          />
        </Box>
        {studentList?.map((elem, index) => (
          <Box
            key={index}
            onClick={() => {
              // cardMaxMarks && saveStudentInfo && saveStudentInfo(elem);
              if (
                current_assessmemt_classStats?.assessment?.modeOfConduction ===
                ModeOfConductionEnum.MODE_OF_CONDUCTION_GENEO_OMR
              ) {
                // const studentId = String(elem.studentId).split(' - ')[1];
                // cardOnClickHandler && cardOnClickHandler(String(studentId));
                cardOnClickHandler &&
                  cardOnClickHandler(String(elem.studentId));
              } else {
                cardOnClickHandler &&
                  cardOnClickHandler(String(elem.studentId));
              }
            }}
            sx={{ cursor: 'pointer' }}
          >
            <StudentScoreCard
              studentName={elem.name}
              maxMarks={cardMaxMarks}
              submissionType={cardSubmissionType}
              submission={
                (statusInfo &&
                  statusInfo[elem.studentId.toString()]?.isSubmitted) ||
                false
              }
              score={Math.round(elem.scorePercent)}
              marks={statusInfo && statusInfo[elem.studentId.toString()]?.marks}
              imageUrl={
                'profileImgUrl' in elem && elem.profileImgUrl
                  ? getMediaBasePath(elem.profileImgUrl) ||
                    firstLetterImage(elem.name)
                  : firstLetterImage(elem.name)
              }
              checkBoxClickHandler={checkBoxClickHandler as any}
              studentPerformanceInfo={elem}
              textClickHandler={textClickHandler as any}
            ></StudentScoreCard>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
